<template>
  <modal :id="modalId" @shown="onShown()">

    <template v-slot:header>
      <h4 class="modal-title">{{ title }}</h4>
    </template>

    <vue-load-image v-if="imageShown">
      <template #image>
        <img class="img-preview" :src="imageUrl" :alt="title"/>
      </template>
      <template #preloader>
        <div class="text-center">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
        </div>
      </template>
      <template #error>Error loading image.</template>
    </vue-load-image>

    <template #footer>
      <button type="button" class="btn btn-white" @click="hideModal()">
        <i class="fa fa-fw fa-ban"></i> Close
      </button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
import VueLoadImage from 'vue-load-image'

export default {

  /**
   *
   * Modal dialog for displaying the full-size image.
   *
   * Input properties:
   *
   * modalId - custom id for modal component.
   * title   - modal title.
   *
   * Usage examples:
   *
   * <image-view-modal modal-id="imageModal" title="Full image" image-url="http://site.com/image.png">
   * </image-view-modal>
   *
   * Trigger example:
   *
   * <a href="#" class="btn btn-default" @click="$modal.show('imageModal')">Show full image</a>
   *
   */

  mixins: [HasModal],

  components: {
    'vue-load-image': VueLoadImage
  },

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'imageModal'
    },

    // Modal title.
    title: {
      type: String,
      default: ""
    },

    imageUrl: {
      type: String,
      default: ""
    },

  },

  /**
   * Variables (models).
   */
  data() {
    return {
      imageShown: false,
    }
  },

  /**
   * Functions (methods).
   */
  methods: {
    onShown() {
      console.log(this.imageUrl);
      if (this.imageUrl !== "") {
        if (!this.imageShown) {
          this.imageShown = true;
        }
      }
    },
  }
}
</script>
